var _style, _path, _path2, _path3, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSb(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 512 512",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#496E2D;}\n\t.st1{fill:#0052B4;}\n\t.st2{fill:#FFDA44;}\n\t.st3{fill:#F0F0F0;}\n")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M437,437c96-96,99.8-249.3,11.4-349.9L256,256L87.2,448.4C187.7,536.8,341,533,437,437z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M75,75c96-96,249.3-99.8,349.9-11.4L256,256L63.6,424.8C-24.8,324.3-21,171,75,75L75,75z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M424.8,63.6L63.6,424.8C67.2,429,71,433.1,75,437c4,4,8,7.8,12.2,11.4L448.4,87.2C444.8,83,441,78.9,437,75 C433.1,71,429,67.2,424.8,63.6L424.8,63.6z"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M107.9,89l5.5,17h17.9l-14.5,10.5l5.5,17L107.9,123l-14.5,10.5l5.5-17L84.5,106h17.9L107.9,89z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M199.2,89l5.5,17h17.9l-14.5,10.5l5.5,17L199.2,123l-14.5,10.5l5.5-17L175.8,106h17.9L199.2,89z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M107.9,178.1l5.5,17h17.9l-14.5,10.5l5.5,17l-14.5-10.5l-14.5,10.5l5.5-17l-14.5-10.5h17.9L107.9,178.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M199.2,178.1l5.5,17h17.9l-14.5,10.5l5.5,17l-14.5-10.5l-14.5,10.5l5.5-17l-14.5-10.5h17.9L199.2,178.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M153.5,133.6l5.5,17h17.9l-14.5,10.5l5.5,17l-14.5-10.5l-14.5,10.5l5.5-17l-14.5-10.5H148L153.5,133.6z"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSb);
export default __webpack_public_path__ + "static/media/sb.d4cf1328b0ab35bb9b813b8caed62161.svg";
export { ForwardRef as ReactComponent };